import request from '@/utils/request'
/* 文化活动 */
// 活动列表
export function getActivityList (params) {
  return request({
    url: '/portal/activity/get-list',
    method: 'GET',
    params
  })
}
// 活动管理详情
export function getActivityInfo (params) {
  return request({
    url: '/portal/activity/get-info',
    method: 'GET',
    params
  })
}
// 活动报名
// 活动的表单列表
export function getActivityFormInfo (params) {
  return request({
    url: '/portal/join-activity/get-form-list',
    method: 'GET',
    params
  })
}

// 报名详情
export function getActivityJoinInfo (params) {
  return request({
    url: '/portal/join-activity/get-info',
    method: 'GET',
    params
  })
}

// 活动报名
export function joinActivity (data) {
  return request({
    url: '/portal/join-activity/join',
    method: 'POST',
    data
  })
}

// 活动报名撤回
export function revokeJoinActivity (data) {
  return request({
    url: '/portal/join-activity/revoke',
    method: 'POST',
    data
  })
}

// 活动图片列表
export function getActivePictureList (params) {
  return request({
    url: '/portal/active-picture/get-list',
    method: 'GET',
    params
  })
}
// 活动图片详情
export function getActivePictureInfo (params) {
  return request({
    url: '/portal/active-picture/get-info',
    method: 'GET',
    params
  })
}

// 新闻列表
export function getNewsList (params) {
  return request({
    url: '/portal/news/get-list',
    method: 'GET',
    params
  })
}
// 新闻详情
export function getNewsInfo (params) {
  return request({
    url: '/portal/news/get-info',
    method: 'GET',
    params
  })
}

/* 个人中心我的 */
// 我报名的活动
export function getMyActivityList (params) {
  return request({
    url: '/portal/activity/get-join-activity-list',
    method: 'GET',
    params
  })
}

// // 查看/下载文件
// export function uploaddownloadfile (data) {
//   return request({
//     url: '/common/upload-file/download-file',
//     method: 'POST',
//     data
//   })
// }